<div class="explanation-title">
  <h2>{{ "HowToTrain.title" | translate }}</h2>
  <aside>{{ "HowToTrain.secondary" | translate }}</aside>
</div>
<div class="switch">
  @for(item of data; track $index){
  <button class="switch-btn" (click)="displayExplanation(item)" [ngClass]="{ active: item.active }">
    <div class="innerButton">
      <img class="item-img" [ngClass]="{ active: item.active }"
        src="{{ item.active ? item.iconActived : item.iconDeactived }}" alt="icon" />
      <span> {{ item.name | translate }}</span>
      <div class="arrow">
        @if(item.active){
        <img src="assets/images/svg/arrowLower.svg" alt="arrow" />
        }
      </div>
    </div>
  </button>
  }
</div>
<div class="explanation-contain">
  <div class="left">
    @for(item of data; track $index){
    <div>
      @if(item.active){
      <div class="left-include img{{ $index }}" alt="sport"></div>
      }
    </div>
    }
  </div>
  <div class="right">
    <div class="phase">
      <ol>
        <li>
          <div class="style">1</div>
          <h3 class="step-title">{{ "HowToTrain.step1.title" | translate }}</h3>
          <aside>{{ "HowToTrain.step1.secondary" | translate }}</aside>
        </li>
      </ol>
      <ol>
        <li>
          <div class="style">2</div>
          <h3 class="step-title">{{ "HowToTrain.step2.title" | translate }}</h3>
          <aside>
            {{ "HowToTrain.step2.secondary" | translate}}
            <a href="v2/compatibility" [routerLink]='["/compatibility"]' style="margin-left: 0.5rem">
              {{ "HowToTrain.link" | translate }}
            </a>
          </aside>
        </li>
      </ol>
      <ol>
        <li>
          <div class="style">3</div>
          <h3 class="step-title">{{ "HowToTrain.step3.title" | translate }}</h3>
          <aside>{{ "HowToTrain.step3.secondary" | translate }}</aside>
        </li>
      </ol>
    </div>
  </div>
</div>